module.exports = __webpack_public_path__ + "img/gb9116_21.prt.3f168f76.jpg";